import React from 'react';

/**
 * Full-width section with cover background + readable overlay.
 * Drop JPG/WebP at `image` path to override the default SVG.
 */
const SectionBackground = ({
  image,
  children,
  className = '',
  overlay = 'light',
  minHeight = 'min-h-0',
  rounded = false,
}) => {
  const overlayClass =
    overlay === 'dark'
      ? 'bg-gradient-to-br from-text/95 via-[#00332a]/90 to-[#004d3f]/88'
      : overlay === 'hero'
        ? 'bg-gradient-to-b from-text/80 via-text/70 to-text/55'
      : overlay === 'medium'
        ? 'bg-gradient-to-b from-background/88 via-background/82 to-background/92'
        : 'bg-gradient-to-br from-background/90 via-background/85 to-background/95';

  return (
    <div
      className={`relative overflow-hidden bg-cover bg-center ${minHeight} ${
        rounded ? 'rounded-3xl' : ''
      } ${className}`}
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className={`absolute inset-0 ${overlayClass}`} aria-hidden="true" />
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default SectionBackground;
